export default "__VITE_ASSET__gE23Fn8x__"